import { CSSProperties } from 'react';
import { ORBIT_NEEDS_ACTION } from '@/theme/colors';

/** The prototype's count on a tab or view: the work left, amber. */
export const WORK_COUNT_STYLE: CSSProperties = {
  display: 'inline-block',
  marginLeft: 6,
  fontSize: 11,
  fontWeight: 600,
  minWidth: 18,
  padding: '0 5px',
  borderRadius: 999,
  background: 'rgba(138, 90, 18, 0.12)',
  color: ORBIT_NEEDS_ACTION,
  textAlign: 'center',
  lineHeight: '16px',
};
